import {
  Boxes,
  CheckCircle2,
  MapPinned,
  Package,
  TagIcon,
  Truck
} from 'lucide-react'

import { Business, useScanState } from '../stores/scanStore'

import { PalletPositionSchema } from '@/services/OutboundV2Service'
import { PalletStatus } from '@/types/customs'

interface PalletCardProps {
  pallet: PalletPositionSchema
}

const PalletCard: React.FC<PalletCardProps> = ({ pallet }) => {
  const { activeBusiness } = useScanState()
  const getPalletStyle = (pallet: PalletPositionSchema) => {
    // stored: 在库中, delivery: 已出库待发货, shipped: 已发货

    // 已发货状态（橙色）
    if (
      activeBusiness === Business.DELIVERY &&
      pallet.status === PalletStatus.SHIPPED
    ) {
      return {
        card: 'bg-orange-50 border-orange-300',
        icon: 'text-orange-600',
        text: 'text-orange-900',
        badge: 'bg-orange-100 text-orange-800'
      }
    }

    // 已出库状态（蓝色）
    if (
      activeBusiness === Business.OUTBOUND &&
      (pallet.status === PalletStatus.DELIVERY || pallet.status === PalletStatus.SHIPPED)
    ) {
      return {
        card: 'bg-blue-50 border-blue-300',
        icon: 'text-blue-600',
        text: 'text-blue-900',
        badge: 'bg-blue-100 text-blue-800'
      }
    }

    // 在库中待扫描（灰色）
    return {
      card: 'bg-white border-gray-300 hover:border-gray-400',
      icon: 'text-gray-400',
      text: 'text-gray-700',
      badge: 'bg-gray-100 text-gray-600'
    }
  }

  const getIcon = (pallet: PalletPositionSchema) => {
    const isDelivery = pallet.status === PalletStatus.DELIVERY
    const isShipped = pallet.status === PalletStatus.SHIPPED

    if (isShipped) return Truck
    if (isDelivery) return CheckCircle2
    return Package
  }

  // const isCurrentPallet = pallet.palletCode === currentQrCode
  const IconComponent = getIcon(pallet)
  const style = getPalletStyle(pallet)

  return (
    <div
      key={pallet.id}
      className={`p-3 rounded-lg border-2 transition-all duration-200 ${style.card}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <IconComponent className={`w-5 h-5 ${style.icon}`} />
          <span className={`font-semibold ${style.text}`}>
            {pallet.palletCode}
          </span>
        </div>
        {/* <span
          className={`text-xs px-2 py-1 rounded-full font-medium ${style.badge}`}
        >
          {pallet.statusDisplay}
        </span> */}
      </div>
      <div className="text-xs text-gray-500 mt-1">
        <div className="space-x-4">
          <span>
            <MapPinned className="inline-block w-4 h-4 mr-1 mb-0.5" />
            {pallet.warehousePosition?.name}
          </span>
          <span>
            <TagIcon className="inline-block w-4 h-4 mr-1 mb-0.5" />
            {pallet.cargoMarkAssociations.length} 个唛头
          </span>
          <span>
            <Boxes className="inline-block w-4 h-4 mr-1 mb-0.5" />
            {pallet.cargoMarkAssociations
              .map((item) => item.quantity)
              .reduce((a, b) => a + b, 0)}
            件箱货
          </span>
        </div>
      </div>

      <div className="space-y-2">
        {pallet.cargoMarkAssociations.map((item) => (
          <div key={item.id} className="space-x-2">
            <TagIcon className="inline-block w-4 h-4 mr-1 mb-0.5" />
            <span className="font-semibold">
              {item.cargoMark?.cargoNumber || ''}
            </span>
            <span className="text-gray-500">{item.quantity} 件箱货</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PalletCard
